export const useResponsiveThumbnail = () => {
  const { normalizeThumbnail } = useCasino();

  /**
   * Retorna a variante correta da imagem baseada na largura da viewport
   * - Até 414px: /mobile
   * - 415px até 1024px: /ipad
   * - Acima de 1024px: /public
   */
  function getResponsiveThumbnailSrc(thumbnail: string): string {
    const normalized = normalizeThumbnail(thumbnail);

    if (typeof window === 'undefined') {
      return `${normalized}/mobile`; // SSR fallback
    }

    const width = window.innerWidth;

    if (width <= 414) {
      return `${normalized}/mobile`;
    } else if (width <= 1024) {
      return `${normalized}/ipad`;
    } else {
      return `${normalized}/public`;
    }
  }

  return {
    getResponsiveThumbnailSrc,
  };
};
